export default {
  reservations: 'Reservas',
  activated: 'Ativado',
  deactivated: 'Desativado',
  reservations_deactivated: 'As reservas estão desativadas.',
  tabs: {
    general: 'Geral',
    information: 'Informação',
  },
  sections: {
    notifications_confirmation: 'Notificações e confirmação',
    notifications_confirmation_description: 'Como os convidados reservam e como é notificado.',
    who_can_book: 'Quem pode reservar',
    who_can_book_description: 'Limites de tamanho de grupo para reservas online.',
    when_how_bookings_work: 'Quando e como as reservas funcionam',
    when_how_bookings_work_description:
      'Regras de horário, duração e capacidade que determinam os horários disponíveis para os convidados.',
  },
  google: {
    label: 'Mostrar reservas no Google',
  },
  storefront: {
    label: 'Mostrar reservas na loja online',
  },
  auto_confirm: {
    label: 'Confirmar reservas automaticamente',
  },
  email: {
    label: 'E-mail para reservas recebidas',
    add: 'Adicionar e-mail',
    placeholder: 'Introduzir e-mail',
    required: 'Adicione pelo menos um e-mail para receber novas reservas.',
    invalid: 'Introduza um endereço de e-mail válido.',
  },
  has_whatsapp_phone_number: {
    label: 'Enviar notificações via WhatsApp',
  },
  whatsapp_phone_number: {
    label: 'Número de WhatsApp',
    add: 'Adicionar número de telefone',
  },
  party_size: {
    label: 'Tamanho do grupo permitido por reserva',
    min_label: 'Mín.',
    max_label: 'Máx.',
    to: 'a',
    guests: 'convidados',
    helper:
      'Tamanho mínimo e máximo de uma reserva. Um convidado só pode reservar para um número de pessoas dentro deste intervalo.',
    warning:
      'O Google só aceita reservas para 2–16 convidados. Reservas fora deste intervalo continuarão a funcionar na sua loja online, mas não aparecerão no Google.',
    warning_min: 'O Google recomenda um mínimo de 2 convidados para reservas.',
    warning_max: 'O Google recomenda um máximo de 16 convidados para reservas.',
    min_note: 'O Google não oferecerá reservas para grupos com menos de {{count}} pessoas.',
  },
  time_slot: {
    label: 'Intervalo de reservas',
    helper: 'Os convidados podem reservar em incrementos deste número de minutos.',
    extra: 'ex.: {{example}}',
  },
  reservation_gap: {
    label: 'Limite de reservas antes do fecho',
    helper: 'O último horário em que um convidado pode iniciar uma reserva, contado a partir da hora de fecho.',
    helper_link: 'Ver os seus horários de reservas',
    extra: 'ex.: fecha às 22:00, limite {{example}} min → último início disponível às {{example}}',
  },
  reservation_notice_period: {
    label: 'Antecedência mínima',
    helper: 'Com que antecedência mínima um convidado pode reservar antes da hora de chegada.',
    extra: 'ex.: reservar até às {{example}} para chegada às 18:00',
  },
  opening_times: {
    label: 'Horário de funcionamento',
  },
  total_seats: {
    label: 'Capacidade total de convidados',
    helper:
      'O número máximo de convidados (não de mesas) que podem estar sentados ao mesmo tempo. Conte os lugares individuais — ex.: 5 mesas de 4 = 20.',
  },
  capacity_explainer: {
    title: 'Como funciona a capacidade',
    body: 'Este é o número de convidados que pode acomodar de uma vez. Cada reserva ocupa os seus lugares durante a sua duração e liberta-os para os próximos convidados. O sistema garante espaço suficiente para todos os reservados, evitando overbooking.',
    body_example:
      'Exemplo: com 20 lugares, pode aceitar uma reserva de 12 convidados às 19:00 e uma de 10 convidados às 21:00, porque os lugares do primeiro grupo ficam livres antes da chegada do seguinte.',
  },
  note: {
    label: 'Nota',
  },
  grace_period: {
    label: 'Período de tolerância',
    helper: 'Quanto tempo manter a mesa após a hora de início da reserva.',
    tooltip:
      'Tempo extra adicionado após a duração de uma reserva antes de a mesa ser disponibilizada novamente (ex.: para limpar e preparar a mesa).',
    extra: 'ex.: mantida até às {{example}} para uma reserva às 18:00',
    placeholder: 'Introduzir período de tolerância',
  },
  information: {
    rules: {
      label: 'A sua mesa ficará reservada durante:',
      add: 'Adicionar',
    },
  },
  reservation_duration: {
    label: 'Duração da reserva',
    helper: 'Quanto tempo cada mesa fica reservada por reserva.',
    tooltip:
      'Quanto tempo uma mesa fica reservada por cada reserva. É usado para calcular quando a mesa fica disponível para o próximo convidado.',
    extra: 'ex.: 18:00 – {{example}}',
    minutes: '{{ count }} Minutos',
    hour_one: '{{ count }} Hora',
    hour_other: '{{ count }} Horas',
  },
  buttons: {
    save: 'Guardar',
    activate: 'Ativar',
    deactivate: 'Desativar',
  },
  success_messages: {
    updated: 'Atualização bem-sucedida',
    saving_successful:
      'Atualização bem-sucedida. Tenha em atenção que o Google pode demorar até 24 horas a refletir as alterações.',
  },
  error_messages: {
    invalid_phone_number: 'Número de telefone inválido',
    saving_unsuccessful: 'Erro ao guardar as alterações. Por favor, tente novamente.',
    enter_correct_email: 'Por favor, introduza um endereço de email válido.',
  },
};
